import Repository from "./Repository";

const resource="/matches";

export default {
    /* searchdata - object with keys for each search
    * status,tournament,start_date,end_date,team,team_id
    * */
    get(searchdata=null) {
        let qs="";
        if(searchdata!==null){
            qs=Object.keys(searchdata).map(key => key + '=' + encodeURI(searchdata[key])).join('&');
        }

        if(qs!==""){
            qs="?"+qs;
        }

        return Repository.get(resource+qs);
    },
    getMatch(mid) {
        return Repository.get(resource+"/"+mid);
    },
    getStatsMatch(mid){
        return Repository.get(resource+"/"+mid+"/stats");
    },
    getVsMatch(mid){
        return Repository.get(resource+"/"+mid+"/vs");
    }
}